// extracted by mini-css-extract-plugin
export default {"container":"HUS-7"};